import { gql } from 'graphql-request';

import type { IsicDetail, SiteRiskSummary } from 'src/shared/types/engine';

export { IsicDetail, SiteRiskSummary };

export const riskInsightsOrganisationSitesQuery = gql`
    query RiskInsightsOrganisationSites(
        $businessCentralId: String!
        $page: Int!
        $pageSize: Int!
        $nameContains: String
        $sortBy: GqlSiteSortField
        $sortDir: GqlSortDirection
        $isic: [String!]
        $countries: [String!]
        $physicalRiskLevels: [GqlRiskBandLevel!]
        $dependencyLevels: [GqlRiskBandLevel!]
        $impactLevels: [GqlRiskBandLevel!]
        $sonLevels: [GqlSonBandLevel!]
        $at: DateTime
    ) {
        organisation(businessCentralId: $businessCentralId, at: $at) {
            sites(
                page: $page
                pageSize: $pageSize
                status: ACTIVE
                nameContains: $nameContains
                sortBy: $sortBy
                sortDir: $sortDir
                isic: $isic
                countries: $countries
                physicalRiskLevels: $physicalRiskLevels
                dependencyLevels: $dependencyLevels
                impactLevels: $impactLevels
                sonLevels: $sonLevels
            ) {
                items {
                    id
                    name
                    activity {
                        isicDetail {
                            code
                            description
                            ancestors {
                                code
                                level
                                description
                            }
                        }
                    }
                    geography {
                        countryName
                    }
                    riskSummary {
                        physicalNatureRisk
                        operationalDependencies
                        impactsOnNature
                        stateOfNature
                        assessmentDate
                    }
                }
                pagination {
                    page
                    pageSize
                    totalItems
                    totalPages
                    hasNext
                    hasPrevious
                }
            }
        }
    }
`;

export type RiskInsightsSiteGeography = {
    countryName: string | null;
};

export type RiskInsightsSiteRow = {
    id: string;
    name: string;
    activity: {
        isicDetail: IsicDetail;
    } | null;
    geography: RiskInsightsSiteGeography | null;
    riskSummary: SiteRiskSummary | null;
};

export type RiskInsightsOrganisationSitesResult = {
    organisation: {
        sites: {
            items: RiskInsightsSiteRow[];
            pagination: {
                page: number;
                pageSize: number;
                totalItems: number;
                totalPages: number;
                hasNext: boolean;
                hasPrevious: boolean;
            };
        } | null;
    } | null;
};
